
import { oz } from '@weft/utils';
import { SanitizedStringSchema } from './sanitizedStringSchema';

export const AddressSchema = oz.object({
  country: SanitizedStringSchema.optional(),
  city: SanitizedStringSchema.optional(),
  addressText: SanitizedStringSchema.optional(),
  state: SanitizedStringSchema.optional(),
  postalCode: SanitizedStringSchema.optional(),
}).openapi('Address');

export type Address = oz.infer<typeof AddressSchema>;